<template>
    <div class="container container container-margin" id="about">
        <div class="row">
            <div class="col-1 d-none d-md-block col-md-1 offset-md-2 content-center-aligned">
                <img :src="arrow" class="arrow-icon">
            </div>

            <div class="col-11 col-md-7 content-left-aligned">
                <h2>About</h2>
                <p>
                    Sisterhood is currently in the first stages of development. Making a biographical game is a
                    curious and largely unexplored endeavour, so we are proud to get the chance to develop various
                    prototypes based on the life of
                    <b>Alexandra David-Néel</b> with a grand from the
                    <a
                        href="https://stimuleringsfonds.nl/nl/toekenningen/sisterhood/"
                        target="_blank"
                    >Stimuleringsfonds</a>.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Arrow from "@/assets/img/arrow-icon.svg";

export default {
    name: "AboutText",
    data() {
        return {
            arrow: Arrow
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";
</style>
